/* Beso de Goma - Behavior Tracker v2 (máxima conversión)
   1. Exit-intent -> popup BIENVENIDA10 con cuenta atrás real de 24h
   2. Duda en producto (15s) -> WhatsApp
   3. Carrito con productos (10s) -> recordatorio + urgencia
   4. Indecisión de categoría (2 vistas) -> banner al quiz
   5. Carrito + intento de salida -> popup reforzado (prioridad sobre el genérico)
*/
(function () {
  "use strict";

  var DAY_MS = 24 * 60 * 60 * 1000;
  var now = Date.now();
  var DISCOUNT_EXPIRES_AT = new Date("2026-07-08T00:00:00Z").getTime();

  function getFlag(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function setFlag(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function sessionGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function sessionSet(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function formatCountdown(ms) {
    if (ms <= 0) return null;
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    function pad(n) { return n < 10 ? "0" + n : n; }
    return pad(h) + ":" + pad(m) + ":" + pad(s);
  }

  var isProductPage = document.body.className.indexOf("template-product") !== -1 ||
    window.location.pathname.indexOf("/products/") !== -1;
  var isCartOrCheckout = window.location.pathname.indexOf("/cart") === 0 ||
    window.location.pathname.indexOf("/checkout") === 0;

  /* ---------- estilos compartidos ---------- */
  var style = document.createElement("style");
  style.textContent = [
    "#bg-exit-popup{display:none;position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:99998;}",
    "#bg-exit-popup .bg-exit-box{background:#fff;max-width:420px;margin:10% auto;padding:30px;border-radius:12px;text-align:center;font-family:Arial,sans-serif;position:relative;}",
    "#bg-exit-popup .bg-exit-close{position:absolute;top:10px;right:14px;cursor:pointer;font-size:20px;color:#666;}",
    "#bg-exit-popup h2{margin:0 0 8px;color:#F02E6E;font-size:24px;}",
    "#bg-exit-popup .bg-code{display:inline-block;background:#3D0020;color:#fff;padding:8px 18px;border-radius:6px;font-weight:bold;letter-spacing:1px;margin:10px 0;font-size:18px;}",
    "#bg-exit-popup .bg-timer{font-weight:bold;color:#3D0020;font-size:15px;margin-top:6px;}",
    "#bg-exit-popup button{width:100%;margin-top:14px;padding:14px;background:#F02E6E;color:#fff;border:none;border-radius:6px;font-weight:bold;cursor:pointer;font-size:16px;}",
    "#bg-exit-popup .bg-sub{font-size:12px;color:#888;margin-top:8px;}",
    "#bg-cart-toast,#bg-wa-nudge,#bg-category-banner{position:fixed;z-index:99997;font-family:Arial,sans-serif;box-shadow:0 5px 20px rgba(0,0,0,.2);border-radius:10px;background:#fff;padding:14px 18px;max-width:300px;}",
    "#bg-cart-toast{bottom:100px;right:20px;border-left:5px solid #F02E6E;}",
    "#bg-wa-nudge{bottom:100px;right:20px;border-left:5px solid #25D366;}",
    "#bg-category-banner{top:20px;left:50%;transform:translateX(-50%);border-top:4px solid #F02E6E;text-align:center;max-width:360px;}",
    "#bg-cart-toast a,#bg-wa-nudge a{color:#F02E6E;font-weight:bold;text-decoration:none;}",
    "#bg-category-banner a{color:#F02E6E;font-weight:bold;text-decoration:none;}",
    ".bg-close-x{position:absolute;top:6px;right:10px;cursor:pointer;color:#999;font-size:14px;}"
  ].join("");
  document.head.appendChild(style);

  /* ---------- 1. Exit-intent popup con countdown real ---------- */
  function buildExitPopup() {
    var lastShown = getFlag("bg_exit_shown_at");
    if (lastShown && now - lastShown < DAY_MS) return null;
    if (sessionGet("bg_exit_shown_session")) return null;
    if (now >= DISCOUNT_EXPIRES_AT) return null;

    var wrap = document.createElement("div");
    wrap.id = "bg-exit-popup";
    wrap.innerHTML =
      '<div class="bg-exit-box">' +
      '<span class="bg-exit-close">&times;</span>' +
      "<h2>&iexcl;Espera!</h2>" +
      "<p>Antes de irte, ll&eacute;vate un <strong>10% de descuento</strong> en tu pedido.</p>" +
      '<div class="bg-code">BIENVENIDA10</div>' +
      '<div class="bg-timer" id="bg-timer-text"></div>' +
      "<button>Usar mi descuento</button>" +
      '<div class="bg-sub">Aplica autom&aacute;ticamente al hacer clic</div>' +
      "</div>";
    document.body.appendChild(wrap);

    var timerEl = wrap.querySelector("#bg-timer-text");
    var timerInterval = null;
    function tickTimer() {
      var remaining = DISCOUNT_EXPIRES_AT - Date.now();
      var formatted = formatCountdown(remaining);
      if (!formatted) {
        timerEl.textContent = "";
        clearInterval(timerInterval);
        return;
      }
      timerEl.textContent = "Válido durante: " + formatted;
    }

    function show() {
      if (sessionGet("bg_exit_shown_session")) return;
      wrap.style.display = "block";
      sessionSet("bg_exit_shown_session", true);
      setFlag("bg_exit_shown_at", now);
      tickTimer();
      timerInterval = setInterval(tickTimer, 1000);
    }
    wrap.querySelector(".bg-exit-close").addEventListener("click", function () {
      wrap.style.display = "none";
      if (timerInterval) clearInterval(timerInterval);
    });
    wrap.querySelector("button").addEventListener("click", function () {
      window.location.href = "/discount/BIENVENIDA10?redirect=/collections/all";
    });
    return show;
  }

  var triggerExitPopup = isCartOrCheckout ? null : buildExitPopup();

  if (triggerExitPopup) {
    var armed = false;
    setTimeout(function () {
      armed = true;
    }, 2500);

    document.addEventListener("mouseout", function (e) {
      if (!armed) return;
      if (!e.relatedTarget && e.clientY <= 0) {
        triggerExitPopup();
      }
    });

    var lastScrollY = window.scrollY;
    var lastScrollT = Date.now();
    window.addEventListener(
      "scroll",
      function () {
        if (!armed) return;
        var y = window.scrollY;
        var t = Date.now();
        var dy = lastScrollY - y;
        var dt = t - lastScrollT;
        if (y < 150 && dy > 60 && dt < 450) {
          triggerExitPopup();
        }
        lastScrollY = y;
        lastScrollT = t;
      },
      { passive: true }
    );

    var idleTimer = setTimeout(function () {
      if (armed) triggerExitPopup();
    }, 25000);
    ["mousemove", "keydown", "touchstart", "scroll"].forEach(function (evt) {
      window.addEventListener(evt, function () {
        clearTimeout(idleTimer);
      }, { passive: true, once: true });
    });
  }

  /* ---------- 2. Nudge de WhatsApp en producto (más rápido: 15s) ---------- */
  if (isProductPage) {
    var addedToCart = false;
    document
      .querySelectorAll('form[action*="/cart/add"] button[type="submit"], [name="add"]')
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          addedToCart = true;
        });
      });

    setTimeout(function () {
      if (addedToCart) return;
      if (sessionGet("bg_wa_nudge_shown")) return;
      if (document.getElementById("bg-exit-popup") && document.getElementById("bg-exit-popup").style.display === "block") return;

      var nudge = document.createElement("div");
      nudge.id = "bg-wa-nudge";
      nudge.innerHTML =
        '<span class="bg-close-x">&times;</span>' +
        "<strong>&iquest;Dudas sobre este producto?</strong><br>" +
        '<a href="https://wa.me/34640741037?text=Hola,%20tengo%20una%20duda%20sobre%20este%20producto" target="_blank" rel="noopener">Pregúntanos por WhatsApp &rarr;</a>';
      document.body.appendChild(nudge);
      sessionSet("bg_wa_nudge_shown", true);
      nudge.querySelector(".bg-close-x").addEventListener("click", function () {
        nudge.remove();
      });
    }, 15000);
  }

  /* ---------- 3. Recordatorio de carrito abandonado (más rápido: 10s) ---------- */
  if (!isCartOrCheckout) {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;
        if (sessionGet("bg_cart_toast_shown")) return;

        setTimeout(function () {
          var toast = document.createElement("div");
          toast.id = "bg-cart-toast";
          toast.innerHTML =
            '<span class="bg-close-x">&times;</span>' +
            "<strong>Tienes " + cart.item_count + " producto(s) en tu carrito</strong><br>" +
            '<a href="/checkout">Finalizar compra &rarr;</a>';
          document.body.appendChild(toast);
          sessionSet("bg_cart_toast_shown", true);
          toast.querySelector(".bg-close-x").addEventListener("click", function () {
            toast.remove();
          });
        }, 10000);
      })
      .catch(function () {});
  }

  /* ---------- 4. Navegación por categoría sin compra (2 vistas en vez de 3) ---------- */
  if (isProductPage) {
    var collectionMatch = window.location.pathname.match(/\/collections\/([^/]+)\/products\//);
    var collectionHandle = collectionMatch ? collectionMatch[1] : (document.referrer.match(/\/collections\/([^/]+)/) || [])[1];

    if (collectionHandle) {
      var seen = sessionGet("bg_category_views") || {};
      seen[collectionHandle] = (seen[collectionHandle] || 0) + 1;
      sessionSet("bg_category_views", seen);

      if (seen[collectionHandle] >= 2 && !sessionGet("bg_category_banner_shown")) {
        setTimeout(function () {
          var banner = document.createElement("div");
          banner.id = "bg-category-banner";
          banner.innerHTML =
            '<span class="bg-close-x">&times;</span>' +
            "&iquest;No sabes cuál elegir? " +
            '<a href="/pages/quiz-recomendacion">Haz nuestro test de 1 minuto &rarr;</a>';
          document.body.appendChild(banner);
          sessionSet("bg_category_banner_shown", true);
          banner.querySelector(".bg-close-x").addEventListener("click", function () {
            banner.remove();
          });
        }, 1500);
      }
    }
  }
})();
